// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__2-RJF","col":"styles_col__vmkiN"};